import { LoanBand } from './types';

export const coversAmount = (band: LoanBand, amount: number): boolean =>
  band.start <= amount && (band.end === null || amount <= band.end);
